<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>客服管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{name : 'orderList'}">订单列表</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 退款
    <div class="hx-form-container box-shadow">
      <el-form
        ref="listForm"
        label-width="120px"
        :model="refundParams">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item
              label="退款金额："
              prop="refundAmount">
              <el-input
                clearable
                size="small"
                v-model="refundParams.refundAmount"
                placeholder="请输入退款金额">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button
                size="small"
                type="primary"
                @click="toRefund">
                退款
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>-->
    <!--商品详情列表-->
    <div class="hx-form-container">
      <div class="hx-table-result">
        <el-table
          v-loading="orderTableLoading"
          show-summary
          :summary-method="getSummaries"
          :data="orderTableData"
        >
          <el-table-column align="center" prop="productTitle" label="商品名称"></el-table-column>

          <el-table-column align="center" prop="productPrice" label="商品价格">
            <template slot-scope="scope">
              <span>{{ scope.row.productPrice | formatToFixed2('元') }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="productSpec" label="商品规格"></el-table-column>

          <el-table-column align="center" prop="productQuantity" label="商品数量"></el-table-column>

          <el-table-column align="center" prop="totalAmount" label="商品总价">
            <template slot-scope="scope">
              <span>{{ scope.row.totalAmount | formatToFixed2('元') }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="amount" label="结算金额">
            <template slot-scope="scope">
              <span>{{ scope.row.amount | formatToFixed2('元') }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column
          align="center"
          prop="refundAmount"
          label="已退款金额">
          <template slot-scope="scope">
            <span>{{ scope.row.refundAmount | formatToFixed2('元') }}</span>
          </template>
          </el-table-column>-->
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      refundParams: {
        orderId: "",
        refundAmount: ""
      },
      orderTableData: [],
      orderTableLoading: false
    };
  },
  mounted() {
    this.loadDetailData();
  },
  methods: {
    handleChange(value) {
      console.log(value);
    },
    /**
     * 加载详情页数据
     */
    loadDetailData() {
      const orderId = this.$route.query.id;
      if (orderId) {
        this.refundParams.orderId = orderId;
        this.orderTableLoading = true;
        this.$http({
          url: global.apiUrl + "/orderdetail/detail?orderId=" + orderId,
          method: "GET"
        })
          .then(res => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              const dataList = res.body.data;
              this.orderId = dataList.orderId;
              this.orderTableData = dataList.resultList;
              this.orderTableLoading = false;
            } else {
              this.orderTableLoading = false;
            }
          })
          .catch(err => {
            this.orderTableLoading = false;

            console.error(err);
          });
      }
    },
    /**
     * 获取合计数据
     * @param params
     * @returns {Array}
     */
    getSummaries(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property !== "productPrice") {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            if (column.property !== "productQuantity") {
              sums[index] = sums[index].toFixed(2) + "元";
            }
          } else {
            sums[index] = "";
          }
        }
      });
      return sums;
    }
    // /**
    //  * 退款弹框
    //  */
    // toRefund () {
    //   this.$confirm('此操作将退款，是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.orderRefund();
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消退款'
    //     });
    //   });
    // },
    // /**
    //  * 退款
    //  */
    // orderRefund () {
    //   this.$http({
    //     url : global.apiUrl + '/returnmoney/refund',
    //     method : 'POST',
    //     body : this.refundParams
    //   }).then((res) => {
    //     if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
    //       this.$message.success(res.body.info);
    //       this.resetForm('listForm');
    //       //this.loadDetailData();
    //     } else {
    //
    //     }
    //   }).catch(err => {
    //     this.$message.error('哦，出现了一个错误，请联系管理员');
    //     console.error(err);
    //   });
    // },
    // /**
    //  * 重置退款表单
    //  * @param name
    //  */
    // resetForm (name) {
    //   this.$refs[name].resetFields();
    // }
  }
};
</script>

<style lang="less" scoped>
</style>
